import AuthSessionXModule from "../comp/auth-session-x"


export default function AuthSessionX() {

  return (
    <>
      <AuthSessionXModule />
    </>
  )
}